export const API_URL = `${process.env.GATSBY_BACKEND_URL}/api/download/modules`;
